(() => {
  'use strict';

  const mq = window.matchMedia('(max-width: 749px)');
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const CALC_PATHS = ['/pages/calculer-ses-calories', '/pages/calculer-son-deficit'];

  const isCalcPath = (path = window.location.pathname) => CALC_PATHS.some((value) => path.includes(value));
  const isHomePath = (path = window.location.pathname) => path === '/' || path === '';

  function forceMobilePaint() {
    if (!mq.matches) return;
    document.body?.classList.remove('is-locked');

    const main = $('#MainContent');
    if (!main) return;

    // Safari standalone/BFCache can occasionally restore a page without repainting it.
    // Force one cheap reflow/repaint instead of leaving the user on a white screen.
    main.style.setProperty('visibility', 'visible', 'important');
    main.style.setProperty('opacity', '1', 'important');
    void main.offsetHeight;
    main.style.transform = 'translateZ(0)';
    requestAnimationFrame(() => { main.style.transform = ''; });
  }

  function cleanHardNavParameter() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('_lmds_app_nav')) return;
    url.searchParams.delete('_lmds_app_nav');
    const clean = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, '', clean);
  }

  function calculatorSafetyCheck() {
    if (!mq.matches || !isCalcPath()) return;

    const verify = () => {
      forceMobilePaint();
      const main = $('#MainContent');
      const calculator = $('[data-lmds-calculator]');
      const hasUsefulMain = !!main && main.getBoundingClientRect().height > 160;
      if (calculator && hasUsefulMain) {
        sessionStorage.removeItem('lmds:calc-reload-guard');
        return;
      }

      // One automatic recovery only. This targets the exact iOS/Safari symptom where
      // the calculator route is restored blank and a manual refresh fixes it.
      if (sessionStorage.getItem('lmds:calc-reload-guard') === '1') return;
      sessionStorage.setItem('lmds:calc-reload-guard', '1');
      const url = new URL('/pages/calculer-ses-calories', window.location.origin);
      url.searchParams.set('_lmds_app_nav', String(Date.now()));
      window.location.replace(url.toString());
    };

    requestAnimationFrame(() => requestAnimationFrame(verify));
    setTimeout(verify, 180);
  }

  function initBottomNav() {
    const nav = $('[data-mobile-app-nav]');
    if (!nav) return;

    const items = $$('[data-mobile-app-tab]', nav);
    const setActive = (key) => {
      items.forEach((item) => {
        const active = item.dataset.mobileAppTab === key;
        item.classList.toggle('is-active', active);
        if (active) item.setAttribute('aria-current', 'page');
        else item.removeAttribute('aria-current');
      });
    };

    const syncFromLocation = () => {
      const path = window.location.pathname;
      const hash = window.location.hash;
      if (isCalcPath(path)) setActive('calculator');
      else if (
        document.body.classList.contains('template-product') ||
        document.body.classList.contains('template-collection') ||
        path.includes('/collections/') ||
        (isHomePath(path) && hash === '#lmds-range')
      ) setActive('catalogue');
      else setActive('home');
    };

    if (nav.dataset.ready !== 'true') {
      nav.dataset.ready = 'true';

      items.forEach((item) => {
        if (item.tagName !== 'A') return;
        item.addEventListener('click', (event) => {
          const key = item.dataset.mobileAppTab;
          setActive(key);

          if (key === 'home' && isHomePath()) {
            event.preventDefault();
            window.history.replaceState(window.history.state, '', '/');
            window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            return;
          }

          if (key === 'catalogue' && isHomePath()) {
            const range = $('#lmds-range');
            if (!range) return;
            event.preventDefault();
            window.history.replaceState(window.history.state, '', '/#lmds-range');
            range.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            return;
          }

          if (key === 'calculator') {
            if (isCalcPath()) {
              event.preventDefault();
              window.history.replaceState(window.history.state, '', '/pages/calculer-ses-calories');
              window.scrollTo({ top: 0, behavior: 'auto' });
              forceMobilePaint();
              return;
            }

            // Force a real document navigation on iOS/Safari. A unique query avoids a
            // broken cached paint; it is removed immediately on the destination page.
            event.preventDefault();
            const target = new URL('/pages/calculer-ses-calories', window.location.origin);
            target.searchParams.set('_lmds_app_nav', String(Date.now()));
            window.location.assign(target.toString());
          }
        });
      });
    }

    syncFromLocation();

    const range = $('#lmds-range');
    if (range && document.body.classList.contains('template-index') && 'IntersectionObserver' in window && nav.dataset.rangeObserverReady !== 'true') {
      nav.dataset.rangeObserverReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        if (!mq.matches) return;
        const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.18);
        if (visible) setActive('catalogue');
        else if (window.location.hash !== '#lmds-range') setActive('home');
      }, { threshold: [0, .18, .4], rootMargin: '-70px 0px -42% 0px' });
      observer.observe(range);
    }

    window.LMDSMobileNavSync = syncFromLocation;
  }

  function initMobileBuybar() {
    const bar = $('[data-mobile-buybar]');
    const root = $('[data-product-root]');
    if (!bar || !root || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';
    const originalForm = $('[data-ajax-product-form]', root);
    const originalButton = $('[data-add-button]', originalForm || root);
    const add = $('[data-mobile-buybar-add]', bar);
    const stickyPrice = $('[data-mobile-buybar-price]', bar);
    const livePrice = $('[data-product-price]', root);

    const sync = () => {
      if (stickyPrice) {
        const selectedOption = root.querySelector('[data-variant-select]')?.selectedOptions?.[0];
        const currentPrice = selectedOption?.dataset.price || livePrice?.querySelector('span')?.textContent || livePrice?.textContent || '';
        stickyPrice.textContent = currentPrice.trim().replace(/\s+/g, ' ');
      }
      if (add && originalButton) {
        add.disabled = originalButton.disabled;
        const label = $('span', add);
        if (label) label.textContent = originalButton.disabled ? 'Épuisé' : 'Ajouter';
      }
    };

    add?.addEventListener('click', () => {
      if (!originalButton || originalButton.disabled) return;
      originalButton.click();
    });

    const variant = $('[data-variant-select]', root);
    variant?.addEventListener('change', () => window.setTimeout(sync, 0));

    const showAfter = root.querySelector('.product-info__price') || root.querySelector('.product-purchase-box');
    if ('IntersectionObserver' in window && showAfter) {
      const observer = new IntersectionObserver(([entry]) => {
        if (!mq.matches) return bar.classList.remove('is-visible');
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      observer.observe(showAfter);
    } else {
      const update = () => bar.classList.toggle('is-visible', mq.matches && window.scrollY > 520);
      window.addEventListener('scroll', update, { passive: true });
      update();
    }
    sync();
  }

  function initSwipeHint() {
    $$('.catalogue-v2__primary,.catalogue-v2__subtabs').forEach((row) => {
      if (row.dataset.appSwipeReady === 'true') return;
      row.dataset.appSwipeReady = 'true';
      if (mq.matches && row.scrollWidth > row.clientWidth) row.setAttribute('data-scrollable', 'true');
    });
  }

  function restoreCatalogueAnchor() {
    if (!mq.matches || !isHomePath() || window.location.hash !== '#lmds-range') return;
    const range = $('#lmds-range');
    if (!range) return;
    requestAnimationFrame(() => range.scrollIntoView({ behavior: 'auto', block: 'start' }));
  }

  function init() {
    cleanHardNavParameter();
    forceMobilePaint();
    initBottomNav();
    initMobileBuybar();
    initSwipeHint();
    restoreCatalogueAnchor();
    calculatorSafetyCheck();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('pageshow', () => {
    document.body?.classList.remove('is-locked');
    init();
  });
  window.addEventListener('pagehide', () => document.body?.classList.remove('is-locked'));
  window.addEventListener('hashchange', () => window.LMDSMobileNavSync?.());
  window.addEventListener('popstate', () => window.LMDSMobileNavSync?.());
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      forceMobilePaint();
      window.LMDSMobileNavSync?.();
      calculatorSafetyCheck();
    }
  });
  document.addEventListener('shopify:section:load', init);
})();
